import { useRef, useEffect, useState } from "react";
import { Footer, Navbar, NavbarUser } from '../../containers';
import "../impressum/impressum.css";
import { useTranslation } from 'react-i18next';
import api from '../../api/axios';

const Datenschutz = () => {

    const { t } = useTranslation();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const footerRef = useRef(null);
    const [footerHeight, setFooterHeight] = useState(0);
    const [navbarHeight, setNavbarHeight] = useState(0);
    const [pictureSrc, setPictureSrc] = useState("");

    useEffect(() => {
        const token = sessionStorage.getItem("token");
        setIsAuthenticated(!!token);
        if (footerRef.current) {
            setFooterHeight(footerRef.current.clientHeight);
        }
        const navbarElement = document.querySelector('.navbarHomepage');
        if (navbarElement) {
            const navbarHeight = navbarElement.offsetHeight;
            setNavbarHeight(navbarHeight);
        }

        const fetchPicture = async () => {
            try {
                const pictureId = 22;
                const response = await api.get(`/user/getwebsitepicture/${pictureId}`);
                setPictureSrc(response.data.picture);
            } catch (err) {
                console.error("Error fetching picture:", err);
            }
        };
        fetchPicture();

        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    return (
        <div className="wrapper-impressum" style={{ backgroundImage: pictureSrc ? `url(${pictureSrc})` : "none" }}>
            {isAuthenticated ? <NavbarUser /> : <Navbar />}
            <div className="impressum-site" id="datenschutz" style={{ minHeight: `calc(100vh - ${footerHeight}px)` }}>
                <div className="impressum-content-parent" style={{ marginTop: `${navbarHeight + 1}px` }}>
                    <h1>{t('PrivacyPolicyTitle')}</h1>
                    <div className="impressum-content-child">
                        <div className="long-content">

                            {/* 1. Datenschutz auf einen Blick */}
                            <h2>{t('Privacy1Heading')}</h2>
                            <h3>{t('Privacy1Sub1')}</h3>
                            <p>{t('Privacy1Sub1Text')}</p>

                            <h3>{t('Privacy1Sub2')}</h3>
                            <h4>{t('Privacy1Sub2Q1')}</h4>
                            <p>{t('Privacy1Sub2A1')}</p>
                            <h4>{t('Privacy1Sub2Q2')}</h4>
                            <p>{t('Privacy1Sub2A2')}</p>
                            <p>{t('Privacy1Sub2A2b')}</p>
                            <h4>{t('Privacy1Sub2Q3')}</h4>
                            <p>{t('Privacy1Sub2A3')}</p>
                            <h4>{t('Privacy1Sub2Q4')}</h4>
                            <p>{t('Privacy1Sub2A4')}</p>
                            <p>{t('Privacy1Sub2A4b')}</p>

                            {/* 2. Hosting */}
                            <h2>{t('Privacy2Heading')}</h2>
                            <p>{t('Privacy2Text')}</p>
                            <h3>{t('Privacy2Sub1')}</h3>
                            <p>{t('Privacy2Sub1Text')}</p>
                            <p>{t('Privacy2Sub1Link')}</p>
                            <p>{t('Privacy2Sub1Legal')}</p>
                            <h3>{t('Privacy2Sub2')}</h3>
                            <p>{t('Privacy2Sub2Text')}</p>

                            {/* 3. Allgemeine Hinweise und Pflichtinformationen */}
                            <h2>{t('Privacy3Heading')}</h2>
                            <h3>{t('Privacy3Sub1')}</h3>
                            <p>{t('Privacy3Sub1Text')}</p>
                            <p>{t('Privacy3Sub1Text2')}</p>
                            <p>{t('Privacy3Sub1Text3')}</p>

                            <h3>{t('Privacy3Sub2')}</h3>
                            <p>{t('Privacy3Sub2Text')}</p>
                            <p>
                                {t('Privacy3Sub2Name')}<br />
                                {t('Privacy3Sub2Street')}<br />
                                {t('Privacy3Sub2City')}<br />
                                {t('Privacy3Sub2Phone')}<br />
                                {t('Privacy3Sub2Email')}
                            </p>
                            <p>{t('Privacy3Sub2Explain')}</p>

                            <h3>{t('Privacy3Sub3')}</h3>
                            <p>{t('Privacy3Sub3Text')}</p>

                            <h3>{t('Privacy3Sub4')}</h3>
                            <p>{t('Privacy3Sub4Text')}</p>

                            <h3>{t('Privacy3Sub5')}</h3>
                            <p>{t('Privacy3Sub5Text')}</p>

                            <h3>{t('Privacy3Sub6')}</h3>
                            <p>{t('Privacy3Sub6Text')}</p>

                            <h3>{t('Privacy3Sub7')}</h3>
                            <p><strong>{t('Privacy3Sub7Text')}</strong></p>
                            <p><strong>{t('Privacy3Sub7Text2')}</strong></p>

                            <h3>{t('Privacy3Sub8')}</h3>
                            <p>{t('Privacy3Sub8Text')}</p>

                            <h3>{t('Privacy3Sub9')}</h3>
                            <p>{t('Privacy3Sub9Text')}</p>

                            <h3>{t('Privacy3Sub10')}</h3>
                            <p>{t('Privacy3Sub10Text')}</p>

                            <h3>{t('Privacy3Sub11')}</h3>
                            <p>{t('Privacy3Sub11Text')}</p>
                            <p>{t('Privacy3Sub11List1')}</p>
                            <p>{t('Privacy3Sub11List2')}</p>
                            <p>{t('Privacy3Sub11List3')}</p>
                            <p>{t('Privacy3Sub11List4')}</p>
                            <p>{t('Privacy3Sub11Text2')}</p>

                            <h3>{t('Privacy3Sub12')}</h3>
                            <p>{t('Privacy3Sub12Text')}</p>
                            <p>{t('Privacy3Sub12Text2')}</p>

                            <h3>{t('Privacy3Sub13')}</h3>
                            <p>{t('Privacy3Sub13Text')}</p>

                            {/* 4. Datenerfassung auf dieser Website */}
                            <h2>{t('Privacy4Heading')}</h2>

                            <h3>{t('Privacy4Sub1')}</h3>
                            <p>{t('Privacy4Sub1Text')}</p>
                            <p>{t('Privacy4Sub1Text2')}</p>
                            <p>{t('Privacy4Sub1Text3')}</p>
                            <p>{t('Privacy4Sub1Text4')}</p>
                            <p>{t('Privacy4Sub1Text5')}</p>

                            <h3>{t('Privacy4Sub2')}</h3>
                            <p>{t('Privacy4Sub2Text')}</p>
                            <p>{t('Privacy4Sub2Text2')}</p>
                            <p>{t('Privacy4Sub2Text3')}</p>

                            <h3>{t('Privacy4Sub3')}</h3>
                            <p>{t('Privacy4Sub3Text')}</p>
                            <p>{t('Privacy4Sub3Text2')}</p>

                            <h3>{t('Privacy4Sub4')}</h3>
                            <p>{t('Privacy4Sub4Text')}</p>
                            <p>
                                {t('Privacy4Sub4List1')}<br />
                                {t('Privacy4Sub4List2')}<br />
                                {t('Privacy4Sub4List3')}<br />
                                {t('Privacy4Sub4List4')}
                            </p>
                            <p>{t('Privacy4Sub4Text2')}</p>

                            {/* 5. Zahlungsabwicklung */}
                            <h2>{t('Privacy5Heading')}</h2>
                            <p>{t('Privacy5Text')}</p>
                            <p>
                                {t('Privacy5List1')}<br /><br />
                                {t('Privacy5List2')}<br /><br />
                                {t('Privacy5List3')}<br /><br />
                                {t('Privacy5List4')}
                            </p>

                            {/* 6. E-Mail-Versand */}
                            <h2>{t('Privacy6Heading')}</h2>
                            <p>{t('Privacy6Text')}</p>
                            <p>
                                {t('Privacy6List1')}<br />
                                {t('Privacy6List2')}<br />
                                {t('Privacy6List3')}
                            </p>

                            {/* 7. Google Calendar API */}
                            <h2>{t('Privacy7Heading')}</h2>
                            <p>{t('Privacy7Text')}</p>

                            {/* 8. Persönlichkeitsfragebogen und Matching */}
                            <h2>{t('Privacy8Heading')}</h2>
                            <p>{t('Privacy8Text')}</p>
                            <p>
                                {t('Privacy8List1')}<br />
                                {t('Privacy8List2')}<br />
                                {t('Privacy8List3')}
                            </p>
                            <p>{t('Privacy8List4')}</p>
                            <p>{t('Privacy8List5')}</p>

                            {/* 9. Quelle */}
                            <p>
                                <em>{t('Privacy9Heading')} <a href="https://www.e-recht24.de" target="_blank" rel="noopener noreferrer">{t('Privacy9Text')}</a></em>
                            </p>

                        </div>
                    </div>
                </div>
            </div>
            <div ref={footerRef}>
                <Footer></Footer>
            </div>
        </div>
    );
};

export default Datenschutz;
